<div class="flex flex-col items-center gap-y-2.5">
  <svg
    class="size-[37px] origin-center overflow-visible"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 37 37"
    xmlns="http://www.w3.org/2000/svg">
    <path
      class="stroke-black/10 transition-colors duration-500"
      d="M0.37 18.5 C0.37 5.772 5.772 0.37 18.5 0.37 S36.63 5.772 36.63 18.5 S31.228 36.63 18.5 36.63 S0.37 31.228 0.37 18.5"
      fill="none"
      pathLength="100"
      stroke-width="5" />
    <path
      class="animate-travel stroke-anis transition-colors duration-500"
      d="M0.37 18.5 C0.37 5.772 5.772 0.37 18.5 0.37 S36.63 5.772 36.63 18.5 S31.228 36.63 18.5 36.63 S0.37 31.228 0.37 18.5"
      fill="none"
      pathLength="100"
      stroke-width="5"
      style="stroke-dasharray: 15, 85; stroke-linecap: round" />
  </svg>
  @if (text(); as text) {
    <span class="text-center text-[14px]">{{ text }}</span>
  }
</div>
